import { IconWebhook } from '@tabler/icons-react';
import plugLeadLogo from '@assets/logo/partners/plug-lead.png';
import activeCampaignLogo from '@assets/logo/partners/activecampaign.png';

export const PLATFORMS = {
    pluglead: {
        key: 'pluglead',
        name: 'PlugLead',
        logo: plugLeadLogo,
    },
    activecampaign: {
        key: 'activecampaign',
        name: 'ActiveCampaign',
        logo: activeCampaignLogo,
    },
    webhook: {
        key: 'webhook',
        name: 'Webhook',
        logo: null,
        icon: IconWebhook,
    },
};

// Built from the caller's `t` so the labels follow the active language.
export const getEvents = (t) => ({
    'payments.confirmed': t('events.paymentsConfirmed'),
    'payments.pix_generated': t('events.paymentsPixGenerated'),
    'payments.checkout_dropped': t('events.paymentsCheckoutDropped'),
});
